import { makeAutoObservable } from 'mobx';
import {
    EVENTS_FILTER,
    IEventsData,
    IUscoreActive,
    SCORED_EVENTS_FILTER,
} from './EventsFeedInterfaces';
import { IRootStoreExporter } from '../../interfaces';
import moment from 'moment';
import { uniq, xor } from 'lodash/fp';

export type EventsDictionary = { [id: string] : IEventsData; };
export class EventsFeedStore implements IRootStoreExporter {
    public currentFilter: EVENTS_FILTER;
    public scoredEventsFilter: SCORED_EVENTS_FILTER;
    public currentSelectedUscore: IUscoreActive;
    public currentHoveredUscore: IUscoreActive = null;
    public isMinimized: boolean;
    public isCollapsed: boolean;
    public defaultEvent: number;
    public collapseClickedValue: boolean;
    public searchString: string = '';
    public impactFilter: number[] = [];
    public showMaximize: boolean;
    public showSearchBar: boolean;
    public searchFocused: boolean;
    public currentEventIds: string[] = [];
    public maxDate: moment.Moment;
    public minDate: moment.Moment;
    public selectedCountries: number[];



    public eventsHandlerWorker: Worker = new Worker(new URL('./Worker.ts', import.meta.url), {
    type: 'module'
  })


    constructor() {
        makeAutoObservable(this);
        this.toInitialState();
    }
    public setMinimized(value: boolean) {
        this.isMinimized = value;
    }
    public setcollapse(value: boolean) {
        this.isCollapsed = value;
    }

    public setCollapseClickedValue(value: boolean) {
        this.collapseClickedValue = value;
    }
    public setDefaultEvent(value: number) {
        this.defaultEvent = value;
    }

    public setCurrentFilter(filter: EVENTS_FILTER) {
        this.currentFilter = filter;
    }

    public setScoredEventsFilter(filter: SCORED_EVENTS_FILTER) {
        this.scoredEventsFilter = filter;
    }

    public toInitialState() {
        this.currentFilter = EVENTS_FILTER.SCORED;
        this.scoredEventsFilter= SCORED_EVENTS_FILTER.ALL
        this.currentSelectedUscore= null
        this.isMinimized= false
        this.showMaximize= true
        this.showSearchBar= false
        this.searchFocused= false
        this.impactFilter = []
        this.currentEventIds = [];
        this.maxDate = null;
        this.minDate = null;
        this.selectedCountries = [];

    }

    public setCurrentSelectedUscore(us: IUscoreActive) {
        this.currentSelectedUscore = us;
    }

    public setCurrentHoveredUscore(us: IUscoreActive) {
        this.currentHoveredUscore = us;
    }

    public setSearchString(str: string) {
        if (!str) {
            this.searchString = '';
            return;
        }
        this.searchString = str;
    }

    public toggleCountry(countryId: number) {
        this.selectedCountries = xor([countryId], this.selectedCountries);
    }

    public addCountry(countryId: number) {
        this.selectedCountries = uniq([...this.selectedCountries, countryId]);
    }

    public removeCountry(countryId: number) {
        this.selectedCountries = this.selectedCountries.filter(
            id => id !== countryId
        );
    }

    public setSelectedCountries(countryIds: number[]) {
        this.selectedCountries = [...countryIds];
    }

    public setImpactFilter(value: number[]) {
        this.impactFilter = value;
    }

    public resetDateFilter() {
        this.minDate = null;
        this.maxDate = null;
    }

    public setShowMaximize(val: boolean) {
        this.showMaximize = val;
    }

    public setShowSearchBar(val: boolean) {
        this.showSearchBar = val;
    }

    public setSearchFocused(val: boolean) {
        this.searchFocused = val;
    }

    public exportKeys() {
        return ['currentFilter', 'currentSelectedUscore', 'isMinimized'];
    }
}

export default new EventsFeedStore();
